import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { queryOptions } from '@tanstack/angular-query-experimental';
import { QueryKeys } from '@portal/app/shared/services/queries/query-keys';
import { FiscalCalendarBFFControllerService } from '@libs/api';
import { QueryParamsService } from '@portal/app/shared/services/queries/query-params.service';

@Injectable({ providedIn: 'root' })
export class FiscalCalendarQueriesService {
  private fiscalCalendarBffService = inject(FiscalCalendarBFFControllerService);
  private queryParamsService = inject(QueryParamsService);

  fiscalCalendar() {
    const { clientId, brandId } = this.queryParamsService.queryParams();
    return queryOptions({
      queryKey: [QueryKeys.FiscalCalendar, clientId, brandId],
      queryFn: () =>
        lastValueFrom(
          this.fiscalCalendarBffService.fiscalCalendarBffControllerGetFiscalCalendar(
            clientId,
            brandId
          )
        ),
      enabled: !!clientId && !!brandId
    });
  }
}
